module.exports = __webpack_public_path__ + "img/ongle-incarne3.03d20e91.png";